import React from 'react';
import { icons } from '~/assets';
import Dialog from '~/components/dialog';
import RadioButton from '~/components/radioButton';
import * as St from '~/views/Consult/User/Detail/styles';

interface BlackListCardsDialogProps {
  open: boolean;
  cards: any[];
  selectedCardId: string;
  onClose: () => void;
  onConfirm: () => void;
  onSelectCard: (cardId: string) => void;
}

const BlackListCardsDialog: React.FC<BlackListCardsDialogProps> = ({
  open,
  cards,
  selectedCardId,
  onClose,
  onConfirm,
  onSelectCard,
}) => {
  return (
    <Dialog
      icon={icons.exclamation}
      open={open}
      title={<span style={{ color: 'red', padding: 10 }}> Selecione o cartão que deseja remover da Blacklist </span>}
      positiveLabel="Remover"
      positiveAction={onConfirm}
      negativeAction={onClose}
      negativeLabel="Voltar"
    >
      <St.BlackListCards>
        {cards?.map((item) => {
          if (item.blackList) {
            return (
              <div className="card" key={item.numeroCartao}>
                <RadioButton
                  id={item.numeroCartao}
                  name={item.numeroCartao}
                  checked={selectedCardId === item.id}
                  onClick={() => onSelectCard(item.id)}
                />
                <div className="card-number">{item.numeroCartao}</div>
              </div>
            );
          }
          return null;
        })}
      </St.BlackListCards>
    </Dialog>
  );
};

export default BlackListCardsDialog;
